// extracted by mini-css-extract-plugin
export default {"controllerWrapper":"systemHistoryHeader_controllerWrapper__QaOzz","hide":"systemHistoryHeader_hide__MJWmF"};